import { styled } from '@mui/material/styles';
import { renderTypographyStyles } from 'mui/base/utils';
import { layoutHorizontalGapStyles, layoutVerticalGapStyles } from '../../sharedStyles/layoutStyles';

export const StyledSection = styled('section')(
  ({ theme, isRichText }) => `
  position: relative;

  ${layoutVerticalGapStyles({ theme })};
  ${layoutHorizontalGapStyles({ theme })};
  margin: ${isRichText ? '2rem auto' : null};
 
  h2 {
   max-width: 24ch;
  }
  
  ${theme.breakpoints.up('lg')} {
      margin: ${isRichText ? `${theme.DS_spacing(['lg'])} 0` : '0px 7.5rem 3.75rem'};

     h2 {
       margin-bottom: ${theme.DS_spacing(['md'])};
     }
     > div > div {
     padding: ${theme.DS_spacing(['xl'])} ${theme.DS_spacing(['xxl'])} ;     
     }
  }
   
`,
);

const layoutVariantStyles = ({ $layoutVariant, theme, isRichText }) =>
  $layoutVariant === 'Layout Grid'
    ? `
       grid-template-columns: 1fr;
     
     ${theme.breakpoints.up('md')} {
         grid-template-columns: 1fr 1fr;
     }
     ${theme.breakpoints.up('lg')} {
         grid-template-columns: ${isRichText ? `1fr 1fr;` : `1fr 1fr 1fr`};
     }
      

    `
    : $layoutVariant === 'Layout Path'
    ? ` 
       max-width: 680px;
       display: flex;
       flex-direction:column;
       margin-right: auto;
       margin-left: auto;
       position: relative;
       gap: 0;
       > * {
         height: 120px;
         > .info-text {
           max-width: 160px;
           ${theme.breakpoints.up('md')} {
             max-width: unset;
           }
         }
           
       }
       > div:last-of-type {
        >  .line-draw {
         display: none;
        }
       }
   
       
       
        > div:nth-child(even){
          > .info-number {
            right: 100px;
            left: unset;
              ${theme.breakpoints.up('md')} {
                 right: 140px;
              }
          }
 
          > .info-text {
            right: 100px;
            text-align: right;
              ${theme.breakpoints.up('md')} {
                  right: 0;
            
              }
          }
         > div:has(img) {
          position: absolute;
          right: 0;
         }
         
         > .line-draw {
          border-top-left-radius: 60px;
          border-bottom-left-radius: 60px;
          border-right: none;
          border-bottom: none;
        
         }

       }
       
       > div:nth-child(odd){
        > .info-number {
            left: 100px;
            right: unset;
              ${theme.breakpoints.up('md')} {
                 left: 140px;
              }
       }
       >.info-text {
          left: 100px;
          ${theme.breakpoints.up('md')} {
            left: 0;
   
          }
       }
       > div:has(img) {
          position: absolute
         }
       > .line-draw {
          border-top-right-radius: 60px;
          border-bottom-right-radius: 60px;
          border-left: none;
          border-bottom: none;

         }
       }
     
     }
     
     ${theme.breakpoints.up('md')} {
        margin: ${theme.DS_spacing(['xl'])} auto !important;
        
     }
  
    `
    : `
   grid-template-columns: repeat(2, minmax(120px, 1fr));
   
     ${theme.breakpoints.up('md')} {
       grid-template-columns: repeat(3, 1fr);

   }

      ${theme.breakpoints.up('lg')} {
       grid-template-columns: ${isRichText ? `repeat(3, 1fr);` : `repeat(4, 1fr)`};

      gap: ${theme.DS_spacing(['xl'])} ${theme.DS_spacing(['md'])};
   }`;

export const StyledGrid = styled('div')(
  ({ theme, $layoutVariant, isRichText }) => `
   display: grid;
   justify-content: center;
   width: 100%;
   margin: ${theme.DS_spacing(['sm'])} 0;
   padding: ${theme.DS_spacing(['xs'])} 0;
   gap: ${theme.DS_spacing(['lg'])} ${theme.DS_spacing(['md'])};

  ${layoutVariantStyles({ theme, $layoutVariant, isRichText })}
${theme.breakpoints.up('lg')} {
   margin: ${theme.DS_spacing(['xl'])} 0;
}
`,
);

export const StyledMarkdown = styled('div')(
  ({ theme }) => `
   > div {
        width: 100%;
        h1, h2, h3 {
          ${renderTypographyStyles(theme.typography.DS_copyBigBold)};
          margin-bottom: ${theme.DS_spacing(['sm'])};
        
        }
   }

   display: flex;
   justify-content: center;
   
  
`,
);
